import { httpClient } from '../http/httpClient'
import {
  SupportRequest,
  SupportRequestReason,
  SupportRequestStatusEnum,
} from '@/app/entities/SupportRequest'

export interface ListMySupportRequestsParams {
  search?: string
  status?: SupportRequestStatusEnum[]
  reason?: SupportRequestReason[]
  limit?: number
  skip?: number
}

export interface ListMySupportRequestsResponse {
  supportRequests: SupportRequest[]
  pagination: {
    limit: number
    skip: number
    total: number
  }
}

export async function listSupportRequests(params?: ListMySupportRequestsParams) {
  const { status, reason, ...rest } = params || {}

  const { data } = await httpClient.get<ListMySupportRequestsResponse>(
    '/support-requests',
    {
      params: {
        ...rest,
        status: status && status.length > 0 ? status.join(',') : undefined,
        reason: reason && reason.length > 0 ? reason.join(',') : undefined,
      },
    },
  )

  return data
}
